import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
    name: 'numberFormat', pure: false // impure pipe because of language change
    ,
    standalone: false
})
export class NumberFormatPipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(value: number | string, digitsInfo?: string): any {
    try {
      return (new DecimalPipe(this.translate.currentLang)).transform(value, digitsInfo);
    } catch (e) {
      console.error(e);
      return value;
    }
  }

}
